import { FfdNoteItem } from './ffd-notes-screen.interface';

export const PLACEHOLDER_FFD_NOTE_ITEM: FfdNoteItem = {
  id: '-1',
  content: 'Patient presents for a slightly overdue 4-month periodontal maintenance (prophy) appointment.',
  title: 'Jane Smith',
  date: new Date().toISOString(),
  hasBeenCopied: true,
};
